(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('[data-read-more]').each(function () {
		var wrap = $(this);
		var maxHeight = wrap.css('max-height');
		var wrapHeight = wrap.css('max-height', 'none').outerHeight();
		var toggler = $('.read-more a[href="#' + wrap.attr('id') + '"]');
		var text = toggler.text();
		var lessText = toggler.attr('data-read-less') || text;

		wrap.css('max-height', maxHeight);

		$(window).resize(function () {
			wrapHeight = wrap.css('max-height', 'none').outerHeight();

			if (!wrap.is('.open')) {
				wrap.css('max-height', maxHeight);
			}
		});

		toggler.click(function (e) {
			e.preventDefault();

			if (wrap.is('.open')) {
				wrap.css('max-height', maxHeight).removeClass('open').scrollTop(0);
				toggler.text(text);
			}
			else {
				wrap.css('max-height', wrapHeight).addClass('open').scrollTop(0);
				toggler.text(lessText);

				setTimeout(function () {
					wrap.css('max-height', 'none');
				}, 200);
			}
		});
	});

	$('[data-trigger-read-more]').on('click', function () {
		var targetId = $(this).attr('data-trigger-read-more');
		var toggler = $('.read-more a[href="' + targetId + '"]');
		var target = $(targetId);

		if (!target.is('.open')) {
			toggler.click();
		}
	});
})();
